export default __webpack_public_path__ + "static/media/question-circle-print.853ab9a3.svg";